import { motion } from "framer-motion";
import { MessageCircle, CalendarClock, Check } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const Cta = ({ onOpenDemo, waLink }) => {
  const { t } = useLanguage();
  return (
  <section className="py-24 lg:py-32 relative" data-testid="cta-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="glass-panel spotlight rounded-3xl p-10 sm:p-16 relative overflow-hidden"
      >
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-neon-violet/20 blur-[100px] pointer-events-none" />
        <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-neon-cyan/20 blur-[100px] pointer-events-none" />

        <div className="relative max-w-3xl">
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-tight">
            {t.cta.titleA} <span className="neon-text">{t.cta.titleNeon}</span>
          </h2>
          <p className="mt-6 text-base lg:text-lg text-white/70">
            {t.cta.subtitle}
          </p>
          <ul className="mt-8 flex flex-col sm:flex-row gap-4 sm:gap-8">
            {t.cta.bullets.map((b) => (
              <li key={b} className="flex items-center gap-2 text-sm text-white/80">
                <Check size={16} className="text-neon-cyan shrink-0" /> {b}
              </li>
            ))}
          </ul>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href={waLink(t.cta.whatsappMessage)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp-button"
              className="flex items-center gap-2 btn-cyber bg-gradient-to-r from-neon-cyan to-neon-violet px-8 py-4 font-semibold text-void hover:opacity-90 hover:-translate-y-0.5 transition-all duration-300"
            >
              <MessageCircle size={18} /> {t.cta.whatsapp}
            </a>
            <button
              onClick={onOpenDemo}
              data-testid="cta-demo-button"
              className="flex items-center gap-2 btn-cyber border border-white/20 px-8 py-4 font-semibold hover:border-neon-cyan/60 hover:text-neon-cyan hover:-translate-y-0.5 transition-all duration-300"
            >
              <CalendarClock size={18} /> {t.cta.demo}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
  );
};

export default Cta;
